import * as React from "react"
import Typed, { TypedOptions } from "typed.js"
import "./typedjs.scss"

interface TypedJs extends React.HTMLProps<HTMLDivElement> {
	strings: string[]
}

const TypedJs: React.FC<TypedJs> = ({ strings, ...props }) => {
	const ref = React.useRef<any>(null!)

	React.useEffect(() => {
		const options: TypedOptions = {
			strings: strings,
			typeSpeed: 90,
			backSpeed: 90,
			backDelay: 1500,
			loop: true,
		}
		const typed = new Typed(ref.current, options)
		return () => typed.destroy()
	}, [strings])

	return (
		<div {...props}>
			<span ref={ref} />
		</div>
	)
}

export default TypedJs
